import { APP_NAME } from 'containers/cantabs/consts/cantabConsts';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import SettingsIcon from '@mui/icons-material/Settings';
import EmojiTransportationIcon from '@mui/icons-material/EmojiTransportation';
import TrackChangesIcon from '@mui/icons-material/TrackChanges';
import EmailIcon from '@mui/icons-material/Email';
import ShareIcon from '@mui/icons-material/Share';
import SensorsIcon from '@mui/icons-material/Sensors';
import HomeWorkIcon from '@mui/icons-material/HomeWork';
import VisibilityIcon from '@mui/icons-material/Visibility';
import WebIcon from '@mui/icons-material/Web';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import DirectionsCarIcon from '@mui/icons-material/DirectionsCar';
import VideoChatIcon from '@mui/icons-material/VideoChat';
import BallotIcon from '@mui/icons-material/Ballot';
import ArticleIcon from '@mui/icons-material/Article';
import PsychologyIcon from '@mui/icons-material/Psychology';
import VideocamIcon from '@mui/icons-material/Videocam';

const appIcons = [
	{ id: 0, name: APP_NAME.CAN_SDS, icon: <AdminPanelSettingsIcon /> },
	{ id: 1, name: APP_NAME.CAN_APPS, icon: <SettingsIcon /> },
	{ id: 2, name: APP_NAME.CAN_DISPATCH, icon: <EmojiTransportationIcon /> },
	{ id: 3, name: APP_NAME.CAN_TRACK, icon: <TrackChangesIcon /> },
	{ id: 4, name: APP_NAME.CAN_MAIL, icon: <EmailIcon /> },
	{ id: 5, name: APP_NAME.ROUTE_CANSHARE, icon: <ShareIcon /> },
	{ id: 6, name: APP_NAME.CAN_SENSE, icon: <SensorsIcon /> },
	{ id: 7, name: APP_NAME.CAN_WORK, icon: <HomeWorkIcon /> },
	{ id: 8, name: APP_NAME.CAN_PROSPECT, icon: <VisibilityIcon /> },
	{ id: 9, name: APP_NAME.CAN_WEBSITE, icon: <WebIcon /> },
	{ id: 10, name: APP_NAME.CAMFM, icon: <LocalShippingIcon /> },
	{ id: 11, name: APP_NAME.CAN_PARK, icon: <DirectionsCarIcon /> },
	{ id: 12, name: APP_NAME.CAN_MEET, icon: <VideoChatIcon /> },
	{ id: 13, name: APP_NAME.CAN_SURVEY, icon: <BallotIcon /> },
	{ id: 14, name: APP_NAME.CAN_BLOG, icon: <ArticleIcon /> },
	{ id: 15, name: APP_NAME.CAN_AI, icon: <PsychologyIcon /> },
	{ id: 16, name: APP_NAME.CAN_VMS, icon: <VideocamIcon /> },
];

export default appIcons;